import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import Card from "../ui/card/card";
import PhoneNumberForm from "../ui/form/phoneNumberForm";
import YouAreAnonymous from "../ui/anonymous/anonymous";
import TermsConditions from "../ui/terms/terms";
import PoweredBy from "../ui/poweredBy/poweredBy";
import useDataStore from "../data/store/useDataStore";
import PageNotExist from "../ui/pageNotExist/pageNotExist";
import Popup from "../ui/popup/popup";

const Login = () => {
  const navigate = useNavigate();
  const { companyId } = useParams();

  const { setCompanyId, fetchData, message } = useDataStore();

  useEffect(() => {
    setCompanyId(companyId);
    fetchData();
  }, []);

  if (message) {
    return (
      <Popup open={true} showCloseBtn={false} height='35vh'>
        <PageNotExist />
      </Popup>
    );
  }

  return (
    <>
      <YouAreAnonymous />
      <div className='root'>
        <Card>
          <PhoneNumberForm onSubmit={() => {
            navigate('/case');
          }} />
        </Card>
      </div>
      <TermsConditions />
      <PoweredBy />
    </>
  );
};

export default Login;
